import React from 'react';
import CheckStubForm from './CheckStubForm'

const CheckStubArrayForm = ({ fields, deleteReduxFormField, meta: { error, submitFailed }}) =>
        {
        	let descriptions= [];
        	switch (fields.length){
        		case 1:
        			descriptions=['Datos de tu recibo de sueldo'];
        			break;
        		case 2:
        			descriptions=['1º Quincena', '2º Quincena'];
        			break;
        		default:
        			descriptions=[];

        	}
            return (<div>
                        {fields.map((member, index) => {
                            return (<CheckStubForm member={member} key={index} description={descriptions[index]} deleteReduxFormField={deleteReduxFormField}/>)

                        })}
                    </div>);
        }


export default CheckStubArrayForm;


/** WEBPACK FOOTER **
 ** ./src/components/CheckStubArrayForm.js
 **/